<template>
  <page-section class="faq" :backgroundColor="backgroundColor || null">
    <div class="faq__text" v-if="introduction">
      {{ introduction }}
    </div>
    <div class="faq__container">
      <FAQ :items="items" :backgroundColor="backgroundColor || null" />
    </div>
  </page-section>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true },
    introduction: { type: String, required: false },
    backgroundColor: { type: String, required: false },
  },
};
</script>

<style lang="scss" scoped>
.faq {
  &__text {
    grid-column: 10/-10;
  }
  &__container {
    grid-column: 10/-10;
  }
}
:deep(.button) {
  display: block;
  margin-bottom: 0.5em;
  border-bottom: 0;
  font-size: 1em;
  &:first-of-type {
    margin-top: 0.5em;
  }
}

.section {
  // &--on-backgroundcolor {
  //   .text {
  //     &__container {
  //       @include mq(small) {
  //         grid-column: 6/-6;
  //       }
  //     }
  //     &__with_subject {
  //       @include mq(small) {
  //         width: calc(var(--column-size) * 26);
  //       }
  //     }
  //   }
  // }
  // &--black {
  // }
}
</style>
